import React, { Component } from "react";
import { Redirect, Link } from "react-router-dom";
import Cookies from "universal-cookie";

import { validateEmail } from "../utils/validation/email";
import { postApiLoginAsyn } from "../Services/PostAPI";
import { getMenuAccess } from "./login-utils";
import Logo from "../images/logo.svg";
import Loginbg from "../images/loginbg.jpg";
import "./Login.css";
import { selectBrandsConfig } from "../Redux/Selectors/brand";
import { connect } from "react-redux";
import CustomHelmet from "../utils/customHelmet";

const cookies = new Cookies();
class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loginValue: {},
      error: false,
      errorMessage: "",
      showPassword: false,
      isLoading: false,
    };
  }

  keyUpEventListener = (event) => {
    if (event.key === "Enter" && !this.checkButtonDisabled()) {
      this.handleLoign();
    }
  };

  componentDidMount = () => {
    window.addEventListener("keyup", this.keyUpEventListener);
  };

  componentWillUnmount = () => {
    window.removeEventListener("keyup", this.keyUpEventListener);
  };

  checkError = (value) => {
    if (value && !validateEmail(value)) {
      return "Please enter a valid email.";
    }
    return false;
  };

  checkButtonDisabled = () => {
    const { loginValue, isLoading } = this.state;
    return (
      isLoading ||
      !loginValue.username ||
      !loginValue.password ||
      this.checkError(loginValue.username)
    );
  };

  handleChangeGen = (event) => {
    const { loginValue } = this.state;
    loginValue[event.target.name] = event.target.value;
    this.setState({ [loginValue]: loginValue, error: false });
  };

  handleLoign = async () => {
    const { loginValue } = this.state;
    this.setState({ isLoading: true, error: false });
    let reqData = { username: loginValue.username, password: loginValue.password };
    let res = await postApiLoginAsyn("login", reqData);
    if (res.authorization != null) {
      await getMenuAccess(res.authorization);
      cookies.set("authorization", res.authorization, { path: "/", sameSite: true });
      this.props.callBack();
    } else {
      this.setState({ isLoading: false, error: true, errorMessage: "Invalid email or password" });
    }
  };
  

  render() {
    const { brandConfig } = this.props;
    const { name, faviconPath, logo } = brandConfig?.config || {};
    const { loginValue, error, errorMessage, showPassword, isLoading } = this.state;
    if (cookies.get("authorization") != null || cookies.get("authorization") !== undefined) {
      return <Redirect to="/Dashboard" />;
    }
    const emailError = this.checkError(loginValue.username);
    return (
      <div className="login">
        <CustomHelmet title={`Welcome to ${name}`} faviconPath={faviconPath} />
        <div className="left_login">
          <img src={Loginbg} alt="Fresh Fuels" />
          <div className="left_login_overlay"></div>
        </div>

        <div className="loginpan">
          <div className="login_card">
            <div className="card_brand">
              <img src={logo || Logo} alt={name} className="card_logo" />
              <span className="card_brand_name">{name}</span>
            </div>
            <h2 className="card_title">Sign in</h2>
            <p className="card_subtitle">Welcome back</p>

            {error && (
              <div className="login-error">
                <span className="login-error-icon">&#9888;</span> {errorMessage}
              </div>
            )}

            <div className="field_group">
              <label className="field_label" htmlFor="login_email">Email</label>
              <div className="input_wrapper user_icon">
                <input
                  id="login_email"
                  className={`login_input${emailError ? " input_error" : ""}`}
                  name="username"
                  type="email"
                  value={loginValue.username || ""}
                  onChange={this.handleChangeGen}
                  placeholder="you@company.com"
                  autoComplete="username"
                />
              </div>
              {emailError && <span className="field_error">{emailError}</span>}
            </div>

            <div className="field_group">
              <label className="field_label" htmlFor="login_password">Password</label>
              <div className="input_wrapper pass_icon">
                <input
                  id="login_password"
                  className="login_input"
                  name="password"
                  type={showPassword ? "text" : "password"}
                  value={loginValue.password || ""}
                  onChange={this.handleChangeGen}
                  placeholder="Enter your password"
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  className="toggle_password"
                  onClick={() => this.setState({ showPassword: !showPassword })}
                  tabIndex={-1}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? "Hide" : "Show"}
                </button>
              </div>
            </div>

            <div className="forgot_row">
              <Link to="/forgot-password" className="forgot_link">Forgot password?</Link>
            </div>

            <button
              className="login_btn"
              disabled={this.checkButtonDisabled()}
              type="button"
              onClick={this.handleLoign}
            >
              {isLoading ? <span className="login_spinner" /> : "Sign In"}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    ...ownProps,
    brandConfig: selectBrandsConfig(state)
  }
}
export default connect(mapStateToProps, null)(Login);
